






import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

@Component
export default class extends Vue {
    @Prop() icon?: string;
    @Prop() color?: string;
    test(){
        this.$emit('click')
    }

}
